import {create} from 'zustand';

interface FleetState {
  fleetTypes: string[];
  loading: boolean;
  setFleetTypes: (fleetTypes: string[]) => void;
  setLoading: (loading: boolean) => void;
}

// Function to map fleet names: A319_A320_A321 -> A320
export const mapFleetName = (fleetName: string): string => {
  if (fleetName === 'A319_A320_A321') {
    return 'A320';
  }
  return fleetName;
};

const useFleet = create<FleetState>((set, get) => ({
  fleetTypes: [],
  loading: true,

  setFleetTypes: (fleetTypes: string[]) => set({fleetTypes}),
  setLoading: (loading: boolean) => set({loading})
}));

export default useFleet;
